import React from "react";
import styles from "./footer.module.css";
import { Icon } from 'antd';

import teploLogoWhite from "../../../files/images/teploLogoWhite.png";
import mailIconWhite from "../../../files/icons/mailIconWhite.png";
import phoneIconWhite from "../../../files/icons/phoneIconWhite.png";

class Footer extends React.Component {
  render() {
    const year = new Date().getFullYear();
    const copyRight = 'ООО «ТЕПЛОИНФОРМ» 2008-' + year + ' г.';
  return (
      <div className={styles.footer}>
        <div style={{ paddingLeft: "2.5vw" }}>
          <img src={teploLogoWhite} style={{ width: "4vw", height: "2.2vw" }} alt="ИС Теплоинформ"/>
        </div>

        <div style={{ paddingLeft: "1.3vw", color: "#ffffffc7" }}>
          <span>{copyRight}</span>
          <br />
          <span>111524, г.Москва, ул.Электродная, дом 10, офис 67</span>
        </div>
        <div style={{ flex: "1" }} />
            <div style={{ paddingRight: "15vw" }}>
                <Icon type="file-pdf" theme="outlined" />
                <a
                    href="Documents/Руководство по эксплуатации АСУТ-601М2.pdf"
                    target="_blank"
                    style={{
                        textDecoration: "underline",
                        paddingLeft: "0.4em",
                        color: "white"
                    }}
                >
                    Скачать руководство ИС "Теплоинформ"
                </a>
            </div>

        <div style={{ paddingRight: "5.3vw" }}>
          <img src={mailIconWhite} style={{ width: "1.2vw", height: "1.2vw" }} alt="info@teplo-inform.ru"/>
          <a
            href="mailto:info@teplo-inform.ru?Subject=General"
            target="_top"
            style={{
              textDecoration: "underline",
              paddingLeft: "0.4em",
              color: "white"
            }}
          >
            info@teplo-inform.ru
          </a>
        </div>
        <div style={{ paddingRight: "2.5vw" }}>
          <table style={{ margin: "0 auto" }}>
            <tbody>
              <tr>
                <td rowSpan="2">
                  <img
                    src={phoneIconWhite}
                    style={{ width: "1.2vw", height: "1.2vw" }}
                    alt="phone icon"
                  />
                </td>
                <td
                  style={{
                    paddingLeft: "0.4em",
                    fontSize: "1vw"
                  }}
                >
                  +7(925)365-59-14
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    paddingLeft: "0.4em",
                    fontSize: "1vw"
                  }}
                >
                  +7(495)672-72-13
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Footer;
